import React, { useContext, useState, useEffect } from 'react'
import { Button, Tooltip } from '@mui/material'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import FullScreenPopup from '../../components/organisms/FullScreenPopup'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
    capitalize,
} from '../../common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Reorder from 'react-reorder'
import { arrayMoveImmutable } from 'array-move'
import SettingContext from '../../context/setting/settingContext'
import DynamicContext from '../../context/dynamic/dynamicContext'
import CustomDialog from '../../components/organisms/Dialog'
import FieldValueManage from './fieldManage'
import Loaders from '../../components/molecules/Loaders'
import './dynamic.css'
import Menu from './menu'

const FieldManage = (props) => {
    const settingcontext = useContext(SettingContext)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const dynamiccontext = useContext(DynamicContext)
    const {
        propertyColumnReOrder,
        propertyColumnStatusAction,
        propertyColumnAction,
        dynamicTableAction,
        responseStatus: responseStatusDynamic,
    } = dynamiccontext

    const [changeStatus, setChangeStatus] = useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenPopupField = (popup, status, data) => {
        if (popup) {
            setManage({ popup, status, data })
        } else {
            setManage({ popup, status: 'new', data: null })
        }
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [isLoading, setIsLoading] = useState(true)
    const [reload, setReload] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const [tableBodyInActive, setTableBodyInActive] = useState([])

    const [viewPage, setViewPage] = useState(0)

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            table: 'dynamic_fields',
            view_page: viewPage,
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                dataValue.active =
                    dataValue.action === 'delete'
                        ? 2
                        : dataValue.action === 'active'
                          ? 1
                          : 0
                delete dataValue.action
                setIsLoading(true)
                setChangeStatus(false)
                propertyColumnStatusAction(values)
            }
        },
    })

    const onSelectMultiProducts = (id, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = id
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            setChangeStatus(true)
        }
    }

    const validationArray = Yup.object({
        label: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            label: '',
            table: 'dynamic_fields',
            active: 1,
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            searchTableAction(values)
        },
    })

    const formikFetch = useFormik({
        initialValues: {
            page: 1,
            limit: 1000,
            order: 'asc',
            orderby: 'df.show_order',
            primaryTable: 'dynamic_fields',
            filters: {
                // active: {
                //     value: '2',
                //     type: 'notin',
                //     field: 'df.active',
                // },
                label: {
                    value: '',
                    type: 'like',
                    field: 'df.label',
                },
                view_page: {
                    value: '',
                    type: 'in',
                    field: 'df.view_page',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTableFetch(values, 'dynamic_fields')
        },
    })

    useEffect(() => {
        if (data.status === 'view') {
            setTableBody([])
            setTableBodyInActive([])
            setIsLoading(true)
            setViewPage(data.id)
            formikSelection.setFieldValue('view_page', data.id)
            formikFetch.values.filters.view_page.value = data.id
            formikFetch.values.page = 1
            formikFetch.values.filters.label.value = ''
            searchTableFetch(formikFetch.values, 'dynamic_fields')
        }
    }, [data])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'dynamic_fields') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records.filter(
                              (inner) => inner.active === 1
                          )
                        : []
                )
                setTableBodyInActive(
                    search_fetch_data.records.length
                        ? search_fetch_data.records.filter(
                              (inner) =>
                                  inner.is_default === 1 && inner.active === 0
                          )
                        : []
                )
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (responseStatusSetting) {
            if (responseStatusSetting.status === 'success') {
                if (responseStatusSetting.from === 'CommunicationSearchTable') {
                    searchTableFetch(formikFetch.values, 'dynamic_fields')
                }
            }
        }
    }, [responseStatusSetting])

    useEffect(() => {
        if (responseStatusDynamic) {
            if (responseStatusDynamic.status === 'success') {
                if (
                    responseStatusDynamic.from === 'propertyColumnStatusAction'
                ) {
                    setChangeStatus(false)
                    // toggleFullScreenPopupField(false)
                    searchTableFetch(formikFetch.values, 'dynamic_fields')
                }
                if (responseStatusDynamic.from === 'propertyColumnAction') {
                    searchTableFetch(formikFetch.values, 'dynamic_fields')
                }
                setIsLoading(false)
            }
        }
    }, [responseStatusDynamic])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    // useEffect(() => {
    //     console.log('manage', manage)
    //     if (manage.status === 'edit') {
    //         formik.setFieldValue('id', manage.id)
    //         const template = tableBody.filter((cat) => cat.id === manage.id)
    //         formik.setFieldValue('label', template[0].label)
    //         formik.setFieldValue('active', template[0].active)
    //     } else {
    //         resetFrom()
    //     }
    // }, [manage])

    const resetFrom = () => {
        formik.setFieldValue('id', 0)
        formik.setFieldValue('label', '')
        formik.setFieldValue('table', 'dynamic_fields')
        formik.handleReset()
    }

    const sizeValues = useFormik({
        initialValues: {
            id: 0,
            class: '',
        },
        enableReinitialize: true,
    })

    const handleSize = (data, size) => {
        propertyColumnAction({
            id: data.id,
            class: size,
            view_page: viewPage,
        })
        setIsLoading(true)
        setReload(!reload)
    }

    const onReorder = async (e, from, to) => {
        let changedArray = tableBody
        changedArray = await arrayMoveImmutable(changedArray, from, to)
        let idOrder = changedArray.map((cat, index) => {
            let orderValue = {
                id: cat.id,
                show_order: index,
            }
            return orderValue
        })
        propertyColumnReOrder({
            array: true,
            data: idOrder,
            table: 'dynamic_fields',
        })
        setIsLoading(true)
        setTableBody(changedArray)
        setReload(!reload)
    }

    return (
        <FullScreenPopup
            modaltitle="Property Management"
            open={data.status === 'view' ? data.popup : false}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <>
                {isLoading ? (
                    <div className="fieldsLoader">
                        <Loaders isLoading={isLoading} />
                    </div>
                ) : (
                    ''
                )}

                <div className="customContainer">
                    <h4 className="pmActiveTitle">Active properties</h4>
                    <div className="reorderOuter">
                        <Reorder
                            reorderId={'title'}
                            reorderGroup={'title'}
                            component="div"
                            // lock="horizontal"
                            className="reorderCnt row"
                            draggedClassName="dragged"
                            touchHoldTime={2500}
                            mouseHoldTime={1000}
                            holdTime={1000}
                            onReorder={onReorder}
                            autoScroll={true}
                            disabled={false}
                            disableContextMenus={true}
                        >
                            {tableBody.map((data, index) => (
                                <div className={`${data?.class}`}>
                                    <div className={`reorderItem `} key={index}>
                                        <Tooltip title="Click and drag to move">
                                            <span className="material-icons dragIcon">
                                                drag_indicator
                                            </span>
                                        </Tooltip>
                                        <div>
                                            <Tooltip title={data.label}>
                                                <h5 className="fieldName">
                                                    {data.label}
                                                </h5>
                                            </Tooltip>
                                            <div className="d-flex">
                                                <Tooltip
                                                    title={`Property Type: ${capitalize(
                                                        data.type
                                                    )}`}
                                                >
                                                    <h6
                                                        className={`fieldType ${data.type}`}
                                                    >
                                                        {data.type}
                                                    </h6>
                                                </Tooltip>
                                                {Boolean(data.is_default) ? (
                                                    <h6 className={`fieldType`}>
                                                        Default
                                                    </h6>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </div>

                                        <Menu
                                            data={data}
                                            key={index}
                                            viewProperty={() =>
                                                toggleFullScreenPopupField(
                                                    true,
                                                    'edit',
                                                    data
                                                )
                                            }
                                            removeProperty={() =>
                                                onSelectMultiProducts(
                                                    data.id,
                                                    'deactive'
                                                )
                                            }
                                            deleteProperty={() =>
                                                onSelectMultiProducts(
                                                    data.id,
                                                    'delete'
                                                )
                                            }
                                            handleSizeOut={handleSize}
                                        />
                                        {/* <div className="roAct">
                                            <Tooltip title="View details">
                                                <Button
                                                    id="dynamicfield_visible"
                                                    onClick={() =>
                                                        toggleFullScreenPopupField(
                                                            true,
                                                            'edit',
                                                            data,
                                                        )
                                                    }
                                                >
                                                    <span className="material-icons">
                                                        visibility
                                                    </span>
                                                </Button>
                                            </Tooltip>

                                            {data.is_default === 1 ? (
                                                <Tooltip title="Remove">
                                                    <Button
                                                        id="dynamicField_close"
                                                        onClick={() =>
                                                            onSelectMultiProducts(
                                                                data.id,
                                                                'deactive',
                                                            )
                                                        }
                                                    >
                                                        <span className="material-icons">
                                                            close
                                                        </span>
                                                    </Button>
                                                </Tooltip>
                                            ) : (
                                                <Tooltip title="Delete">
                                                    <Button
                                                        id="dynamicField_delete"
                                                        onClick={() =>
                                                            onSelectMultiProducts(data.id, 'delete')
                                                        }
                                                    >
                                                        <span className="material-icons">
                                                            close
                                                        </span>
                                                    </Button>
                                                </Tooltip>
                                            )}
                                        </div> */}
                                    </div>
                                </div>
                            ))}
                        </Reorder>
                        <div className="roRt">
                            <PrimaryButton
                                id="fields_create"
                                btnSize="addPropBtn"
                                onClick={() =>
                                    toggleFullScreenPopupField(true, 'new', 0)
                                }
                            >
                                <span className="material-icons">note_add</span>
                                Create Property
                            </PrimaryButton>
                            <h6 className="defaultFieldsTitle">
                                All Properties
                            </h6>
                            {tableBodyInActive.map((data, index) => (
                                <div className="defaultItems" key={index}>
                                    <h5>{data.label}</h5>

                                    <Button
                                        id="dynamicField_add"
                                        onClick={() =>
                                            onSelectMultiProducts(
                                                data.id,
                                                'active'
                                            )
                                        }
                                    >
                                        <span className="material-icons">
                                            add
                                        </span>
                                    </Button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <FieldValueManage
                    data={manage}
                    viewPage={viewPage}
                    function={toggleFullScreenPopupField}
                    tableBody={tableBody}
                    lableLimit={props.lableLimit}
                />

                <CustomDialog
                    title={'Change property status'}
                    open={changeStatus}
                    function={changeChangeStatus}
                    disableBackdropClick
                >
                    <h5>
                        {formikSelection.values.action === 'delete'
                            ? 'Are you sure you want to delete?'
                            : 'Are you sure you want to change the status?'}
                    </h5>
                    <div className="actionWrapper">
                        <Button
                            id="dynamicField_cancel"
                            onClick={() => changeChangeStatus()}
                        >
                            Cancel
                        </Button>
                        <form
                            onSubmit={formikSelection.handleSubmit}
                            autoComplete="nofill"
                        >
                            <PrimaryButton
                                id="fields_confirm"
                                type="submit"
                                label="Confirm"
                            />
                        </form>
                    </div>
                </CustomDialog>
            </>
        </FullScreenPopup>
    )
}

export default FieldManage
